import { useFormik } from "formik";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { object, ref, string } from "yup";
import { changePassword } from "../../services/AuthServices";
import "./AccountDetail.css";

const ChangePasswordModule = ({ setselectedTab }) => {
  const [isNewPassword, setisNewPassword] = useState(false);
  const [isPassword, setisPassword] = useState(false);
  const [isConfirmPassword, setisConfirmPassword] = useState(false);
  const [isDisable, setisDisable] = useState(false);

  const AdminSchema = object().shape({
    current_password: string()
      .required("Please enter current password.")
      .trim("Please enter current password."),

    new_password: string()
      .required("Please enter new password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        "Password must contain 8+ chars, uppercase, lowercase and number"
      )

      .notOneOf(
        [ref("current_password")],
        "New password and old password can't be same"
      ),

    new_password_confirmation: string()
      .required("Please confirm your new password")
      .oneOf(
        [ref("new_password")],
        "New password and confirm password does not match"
      ),
  });

  const submitClicked = async (data) => {
    setisDisable(true);

    await changePassword(data)
      .then((response) => {
        setisDisable(false);

        toast("Password Changed Successfully", { type: "success" });
        setselectedTab(0);
      })
      .catch((error) => {
        setisDisable(false);

        if (error?.response?.status == 422)
          toast(error?.response?.data?.message, { type: "error" });
        else if (error?.response?.status == 500)
          toast(error?.response?.data?.message, { type: "error" });
        else
          toast(error?.response?.data?.message || "Something went wrong", {
            type: "error",
          });
      });
  };

  const { handleSubmit, handleBlur, handleChange, values, errors, touched } =
    useFormik({
      validationSchema: AdminSchema,

      initialValues: {
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
      },
      onSubmit: async () => {
        let formdata = new FormData();
        formdata.append("current_password", values.current_password);
        formdata.append("new_password", values.new_password);
        formdata.append(
          "new_password_confirmation",
          values.new_password_confirmation
        );

        submitClicked(formdata);
      },
    });

  return (
    <div className="dp-security-container">
      {/* Security Header */}
      <div className="dp-profile-card">
        <div className="dp-profile-card-header">
          <div className="dp-profile-card-title">
            <i className="far fa-lock"></i>
            <h3>Change Password</h3>
          </div>
        </div>
        <div className="dp-profile-card-body">
          {/* Password Requirements */}
          <div className="dp-password-requirements">
            <h5>Password Requirements</h5>
            <ul>
              <li>
                <i className="fas fa-check"></i>
                At least 8 characters long
              </li>
              <li>
                <i className="fas fa-check"></i>
                Must contain uppercase letter
              </li>
              <li>
                <i className="fas fa-check"></i>
                Must contain lowercase letter
              </li>
              <li>
                <i className="fas fa-check"></i>
                Must contain a number
              </li>
            </ul>
          </div>

          <form onSubmit={handleSubmit} className="dp-security-form">
            {/* Current Password */}
            <div className="dp-form-group" style={{ marginBottom: '20px' }}>
              <label className="dp-form-label">Current Password <span>*</span></label>
              <div className="dp-form-input-wrapper">
                <input
                  type={isPassword ? "text" : "password"}
                  placeholder="Enter current password"
                  name="current_password"
                  className={`dp-form-input ${touched?.current_password && errors?.current_password ? 'error' : ''}`}
                  value={values.current_password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                <i
                  className={`fal ${isPassword ? 'fa-eye' : 'fa-eye-slash'} dp-form-icon clickable`}
                  onClick={() => setisPassword(!isPassword)}
                ></i>
              </div>
              {touched?.current_password && errors?.current_password && (
                <span className="dp-form-error">{errors.current_password}</span>
              )}
            </div>

            {/* New Password */}
            <div className="dp-form-group" style={{ marginBottom: '20px' }}>
              <label className="dp-form-label">New Password <span>*</span></label>
              <div className="dp-form-input-wrapper">
                <input
                  type={isNewPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  name="new_password"
                  className={`dp-form-input ${touched?.new_password && errors?.new_password ? 'error' : ''}`}
                  value={values.new_password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                <i
                  className={`fal ${isNewPassword ? 'fa-eye' : 'fa-eye-slash'} dp-form-icon clickable`}
                  onClick={() => setisNewPassword(!isNewPassword)}
                ></i>
              </div>
              {touched?.new_password && errors?.new_password && (
                <span className="dp-form-error">{errors.new_password}</span>
              )}
            </div>

            {/* Confirm New Password */}
            <div className="dp-form-group" style={{ marginBottom: '20px' }}>
              <label className="dp-form-label">Confirm New Password <span>*</span></label>
              <div className="dp-form-input-wrapper">
                <input
                  type={isConfirmPassword ? "text" : "password"}
                  placeholder="Confirm new password"
                  name="new_password_confirmation"
                  className={`dp-form-input ${touched?.new_password_confirmation && errors?.new_password_confirmation ? 'error' : ''}`}
                  value={values.new_password_confirmation}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                <i
                  className={`fal ${isConfirmPassword ? 'fa-eye' : 'fa-eye-slash'} dp-form-icon clickable`}
                  onClick={() => setisConfirmPassword(!isConfirmPassword)}
                ></i>
              </div>
              {touched?.new_password_confirmation && errors?.new_password_confirmation && (
                <span className="dp-form-error">{errors.new_password_confirmation}</span>
              )}
            </div>

            {/* Submit Button */}
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <button
                type="submit"
                disabled={isDisable}
                className="dp-submit-btn"
              >
                {isDisable ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Updating...
                  </>
                ) : (
                  <>
                    <i className="fas fa-lock"></i>
                    Update Password
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModule;
